/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Docs_DescriptionInputs */

const en_client_docs_description = /** @type {(inputs: Client_Docs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach documents to client.`)
};

const pt_br2_client_docs_description = /** @type {(inputs: Client_Docs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anexe documentos ao cliente.`)
};

/**
* | output |
* | --- |
* | "Attach documents to client." |
*
* @param {Client_Docs_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_docs_description = /** @type {((inputs?: Client_Docs_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Docs_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_docs_description(inputs)
	return pt_br2_client_docs_description(inputs)
});